import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { CoreModule } from 'src/app/core/core.module';
import { SeriousCasesRoutingModule } from './serious-cases-routing.module';
import { SeriousCasesListComponent } from './serious-cases-list/serious-cases-list.component';

// Los controles de filtro (inputs, desplegables, calendarios) los pone app-filter-panel, que viene de CoreModule
@NgModule({
    declarations: [
        SeriousCasesListComponent
    ],
    imports: [
        CommonModule,
        TableModule,
        CoreModule,
        SeriousCasesRoutingModule
    ]
})
export class SeriousCasesModule { }
